<template>
    <div class="row font-20 font-medium justify-center mb-3">Thông tin nhân viên</div>

    <DxValidationGroup ref="formValidation">
        <div class="row">
            <div class="xs6">
                <DxTextBox
                    label="Tên nhân viên (*)"
                    v-model="ThongTinNhanVien.HoTen"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="512"
                            message="Không được vượt quá 512 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
            <div class="xs6 ml-4">
                <DxTextBox
                    label="CCCD/Hộ chiếu"
                    v-model="ThongTinNhanVien.CCCD"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <!-- <DxRequiredRule message="Không được bỏ trống!" /> -->
                        <DxStringLengthRule
                            :max="50"
                            message="Không được vượt quá 50 ký tự!"
                        />
                        <DxNumericRule message="CCCD phải là số!" />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mt-5">
            <div class="xs12">
                <DxTextBox
                    label="Số điện thoại (*)"
                    v-model="ThongTinNhanVien.SoDienThoai"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="20"
                            message="Không được vượt quá 20 ký tự!"
                        />
                        <DxNumericRule message="Số điện thoại phải là số!" />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mt-5">
            <div class="xs12">
                <DxSelectBox
                    label="Doanh nghiệp (*)"
                    v-model="ThongTinNhanVien.IdDoanhNghiep"
                    :dataSource="{
                        store: DanhSachDoanhNghiep,
                        pageSize: 20,
                        paginate: true,
                    }"
                    display-expr="TenDoanhNghiep"
                    value-expr="IdDnvt"
                    :search-enabled="true"
                    styling-mode="outlined"
                    no-data-text="Không có dữ liệu!"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                    </DxValidator>
                </DxSelectBox>
            </div>
        </div>
    </DxValidationGroup>

    <div class="row justify-space-between mt-3">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Lưu thông tin"
            styling-mode="contained"
            @click="LuuThongTin()"
        />
    </div>
</template>
<script>
import {
    DxTextBox,
    DxSelectBox,
    DxValidationGroup,
    DxButton,
    DxValidator,
} from "devextreme-vue";
import {
    DxRequiredRule,
    DxStringLengthRule,
    DxNumericRule,
} from "devextreme-vue/validator";

export default {
    components: {
        DxSelectBox,
        DxTextBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxStringLengthRule,
        DxNumericRule,
    },
    data() {
        return {
            DanhSachDoanhNghiep: [],
        };
    },
    computed: {
        ThongTinNhanVien: {
            get() {
                return this.$store.state.NhanVien.ThongTinNhanVien;
            },
            set(data) {
                this.$store.commit("NhanVien/Set", {
                    key: "ThongTinNhanVien",
                    data: data,
                });
            },
        },
    },
    methods: {
        Dong() {
            this.$emit("hiddenPopup", "PopupThongTinNhanVien");
        },
        LuuThongTin() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.ThucHienLuuThongTin();
        },
        async ThucHienLuuThongTin() {
            try {
                this.$startLoading;
                let rs;
                if (!this.ThongTinNhanVien.IdNhanVien) {
                    rs = await this.$store.dispatch("NhanVien/TaoMoiNhanVien");
                } else {
                    rs = await this.$store.dispatch("NhanVien/CapNhatNhanVien");
                }
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Lưu thông tin nhân viên thành công!"
                    );
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Lưu thông tin nhân viên thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin nhân viên thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async LayDanhSachDoanhNghiep() {
            try {
                this.DanhSachDoanhNghiep = (
                    await this.$store.dispatch("DoanhNghiep/LayDanhSachDoanhNghiep")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
    },
    created() {
        this.LayDanhSachDoanhNghiep();
    },
    mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
